/* eslint-disable no-unused-vars */

export enum MetaModule {
	// getters
	GET_META = 'MetaModule/GET_META',

	// actions
	CHANGE_META = 'MetaModule/CHANGE_META',
	RESET_META = 'MetaModule/CHANGE_META',

	// mutations
	SET_META = 'MetaModule/SET_META',
}

export enum ConfigModule {
	// getters
	GET_LOADING = 'ConfigModule/GET_LOADING',
	GET_SITE_DATA = 'ConfigModule/GET_SITE_DATA',
	GET_CATEGORIES = 'ConfigModule/GET_CATEGORIES',
	GET_PRODUCT_MODAL = 'ConfigModule/GET_PRODUCT_MODAL',
	GET_CATEGORIES_FEATURED = 'ConfigModule/GET_CATEGORIES_FEATURED',

	// actions
	FETCH_SITE_DATA = 'ConfigModule/FETCH_SITE_DATA',
	CLEAR_STORE = 'ConfigModule/CLEAR_STORE',

	// mutations
	SET_LOADING = 'ConfigModule/SET_LOADING',
	SET_SITE_DATA = 'ConfigModule/SET_SITE_DATA',
}

export enum LanguageModule {
	// getters
	GET_LANGUAGE = 'LanguageModule/GET_LANGUAGE',

	// actions
	CHANGE_LANGUAGE = 'LanguageModule/CHANGE_LANGUAGE',

	// mutations
	SET_LANGUAGE = 'LanguageModule/SET_LANGUAGE',
}

export enum TerminalModule {
	// getters
	GET_PROMPT = 'TerminalModule/GET_PROMPT',

	// actions
	CHANGE_PROMPT = 'TerminalModule/CHANGE_PROMPT',

	// mutations
	SET_PROMPT = 'TerminalModule/SET_PROMPT',
}
